var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Report',{attrs:{"loadedconfig":_vm.loadedconfig,"studentid":_vm.studentid,"selectStudent":_vm.selectStudent,"hideTargets":_vm.hideTargets,"includeTimeSeries":_vm.includeTimeSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }